/* istanbul ignore file */
import { computed, type Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { getJobNumberExists } from '@/api/filter-options'

const STALE_TIME = 60 * 60 * 1000 // 1 hour

export function useJobNumberExists(jobNumber: Ref<string | null>, enabled: boolean) {
  const { data } = useQuery({
    queryKey: computed(() => ['job-number-exists', jobNumber.value]),
    queryFn: () => getJobNumberExists(Number(jobNumber.value!)),
    enabled: computed(() => !!jobNumber.value && enabled),
    staleTime: STALE_TIME,
  })

  const exists = computed(() => data.value === true)

  return { exists }
}
